import { IAnyStrObject } from 'src/types';
import MacleJSBridge from "../../bridges";
import { reportErrorLog } from "../utils";
export function native(method: string, param?: IAnyStrObject) {
  const finalParam = param || {};
  return new Promise((resolve, reject) => {
    MacleJSBridge.invoke(method, finalParam, (invokeStatusCode, res) => {
      const isOk = Number(invokeStatusCode) === 0;
      if (!isOk) {
        reportErrorLog(method, `${res.errMsg || JSON.stringify(res)}`);
        reject(res);
        return;
      }
      resolve(res);
    });
  });
}
